import { getStorage, removeStorage, setStorage } from "@/utils/storage";

export function useStoreTime(storageName: string) {
  function setTime() {
    setStorage(storageName, new Date().getTime() + 1000 * 60);
  }
  function getTime() {
    // if(!getStorage(storageName)) {
    //   setTime();
    // }
    return getStorage(storageName) as string;
  }
  function isFrozen() {
    const nowTime = new Date().getTime();
    // 等待重新获取时不允许重复获取验证码
    if (nowTime < +getTime()) {
      return true;
    }
    return false;
  }
  function calcTime() {
    const storeTime = getTime();
    const nowTime = new Date().getTime();
    if ((storeTime as any) > nowTime) {
      return Math.floor(((storeTime as any) - nowTime) / 1000);
    }
    return 0;
  }
  function storageTimer(getTimeHandler: (time: number) => void) {
    const timer = setInterval(() => {
      const time = calcTime();
      getTimeHandler(time);
      if (time === 0) {
        clearInterval(timer);
      }
    }, 1000);
  }
  function removeTime() {
    removeStorage(storageName);
  }
  return {
    setTime,
    getTime,
    isFrozen,
    storageTimer,
    removeTime,
  };
}
